// src/components/Pick/PictureOfWord.tsx
/* eslint-disable max-len */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import '../../views/writing/slice/slice';
import './PictureOfWord.less';

type CardProps = {
  id: any,
  image?: string,
  alt?: string,
  // Polski podpis pod obrazkiem
  caption?: string,
};

export const PictureOfWord: FC<CardProps> = ({
  id, image, alt, caption,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="pick_word" id={id}>
        {image && (
          <img
            src={image}
            alt={alt || t('games:labels.wordImage')}
            className="pick_word_img"
          />
        )}
      </div>
      {caption && <p className="pick_word_caption">{caption}</p>}
    </>
  );
};

export default PictureOfWord;
